import {
  AUTHENTICATE_USER,
  AUTHENTICATE_APPLICATION,
  LOGIN,
  LOGOUT,
  REFRESH_TOKEN,
  VALIDATE_MIGRATION,
  requestType,
  failedType,
  succeedType,
} from "./../actions/actionTypes";

const initState = {
  authenticated_app: [],
  token: null,
  full_name: null,
  user_name: null,
  role: null,
  is_authenticated: false,
  is_fetching: false,
  err_message: null,
  required_update_password: false,
};

export const authReducer = (state = initState, action) => {
  switch (action.type) {
    case requestType(AUTHENTICATE_USER):
    case requestType(AUTHENTICATE_APPLICATION):
    case requestType(LOGIN):
      return {
        ...state,
        is_fetching: true,
      };
    case failedType(AUTHENTICATE_USER):
    case failedType(AUTHENTICATE_APPLICATION):
    case failedType(LOGIN):
      return {
        ...state,
        is_fetching: false,
        err_message: action.err_message,
      };
    case succeedType(AUTHENTICATE_USER):
      return {
        ...state,
        is_fetching: false,
        is_authenticated: true,
        token: action.access_token,
        full_name: action.full_name,
        user_name: action.user_name,
        required_update_password: action.required_update_password,
      };
    case succeedType(AUTHENTICATE_APPLICATION):
      return {
        ...state,
        is_fetching: false,
        authenticated_app: action.authenticated_app,
      };
    case succeedType(LOGIN):
      return {
        ...state,
        is_fetching: false,
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        token: action.token,
      };
    case requestType(LOGOUT):
    case succeedType(LOGOUT):
    case failedType(LOGOUT):
      return {
        ...state,
      };
    default:
      return state;
  }
};
